import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { rules } from "./rules";
import { fetchIndustryList } from "../../../Industry/utils/slice";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";
import React from "react";

/**
 * Renders a form component for adding or editing a Career Category record.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.form - The form object from the antd form library.
 * @param {string} props.id - The ID of the form.
 * @param {Function} props.handleSubmit - The function to handle form submission.
 * @param {Function} props.onValuesChange - The function to handle form value changes.
 * @param {Object} props.editValues - The values to pre-populate the form with.
 * @return {JSX.Element} The rendered form component.
 */
const FormComponent: React.FC<any> = ({
  form,
  id,
  handleSubmit,
  onValuesChange,
  editValues,
}) => {
  

  const dispatch = useAppDispatch();

  const [industryList, setIndustryList] = useState<any>([]);

  useEffect(() => {
    if (editValues) {
      form.setFieldsValue({
        code: editValues?.code,
        name: editValues?.name,
        description: editValues?.description,
        industry_id: editValues?.industry_id,
      });
    }

    dispatch(fetchIndustryList())
    .then((data: any) => {
      setIndustryList(data.rows);
    })
    .catch((error: any) => error);

  }, [editValues, form]);

/**
 * Process the form data and handle the form submission.
 *
 * @param {any} data - The form data to be processed.
 * @return {void} No return value.
 */
  const onFinish = (data: any) => {
    if (data?.description !== String(data?.description)) {
      data.description = data?.description?.level?.content;
    }
    handleSubmit(data);
  };

  return (
    <>
      <FormBox
        form={form}
        id={id}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
      >
        <Row gutter={15}>
          <Col xs={{ span: 24 }} md={{ span: 24 }}>
            <InputBox.Text
              required
              name="code"
              label="Code"
              rules={rules.code()}
            />
            <InputBox.Text
              required
              name="name"
              label="Name"
              rules={rules.name()}
            />
            <InputBox.Select
              required
              label="Industry"
              name="industry_id"
              showSearch
              className="singleSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={{
                list: industryList,
                valueKey: "id",
                textKey: "industry_name",
              }}
            />
            <InputBox.Editor
              name="description"
              label="Description"
              initValue={form.getFieldValue("description")}
              editorChange={(e: any) => {
                form.setFieldsValue({ description: e });
                onValuesChange();
              }}
            />
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FormComponent;
